import { View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { FormBuilderViewModel } from "./formBuilder-viewModel"
import { TemplateEditorViewModel } from "../templateEditor/templateEditor-viewModel";
import { TemplateListViewModel } from "../templateList/templateList-viewModel";

export class FormBuilderView extends View<FormBuilderViewModel>{
    GetViewUniqueId(): string {
        return "V-AEE02B99-DD84-450F-A77B-61E93342B147"
    }
    loadHtml(): string {
        let element = require('./formBuilder.html').default;
        let style = require('./formBuilder.less');
        return element;
    }
    constructor() {
       super();
    }
    public set templateList(v: TemplateListViewModel) { this._templateList = v; } public get templateList(): TemplateListViewModel { return this._templateList;} private _templateList: TemplateListViewModel;

    public set editor(v: TemplateEditorViewModel) { this._editor = v; } public get editor(): TemplateEditorViewModel { return this._editor;} private _editor: TemplateEditorViewModel;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
